<template>
  <div>
    <page-header
      :actions="headerActionsConfig"
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
    />
    <filter-manager
      ref="filterRef"
      v-model="filterModel"
      class="mb-4"
      :display-advanced="false"
      :filters="filtersConfig"
      search-container-class="d-flex justify-content-end align-items-start"
      search-text=""
      @academicYear="onChangeAcademicYear"
      @period="onChangePeriod"
      @provider="onChangeProvider"
      @specialist="onChangeSpecialist"
      @status="onChangeStatus"
    >
      <div class="col-12 col-md-2 d-flex align-items-start mt-4">
        <ActionButton
          class="search mb-2 col-12 col-md-12 mt-2"
          i="fas fa-search"
          text="Buscar"
          variant="success"
          @click="onSearch"
        />
      </div>
    </filter-manager>
    <div>
      <div class="px-0 px-md-3 px-sm-0">
        <div class="row">
          <div class="d-flex col my-2">
            <em
              class="total-amount-view__icon icon-block color-green fas fa-file"
            />
            <div class="d-flex flex-column col-12">
              <span class="color-secondary-6 font-14">Total de Servicios</span>
              <div class="d-flex align-items-center">
                <div class="color-black font-weight-bold font-25">
                  {{ totalCount }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>

    <custom-separator class="mt-1 mb-4" text="Resultado de Búsqueda" />
    <div class="col-12 col-md-12 align-items-end mt-4">
      <div class="row">
        <div v-if="canShowSellectAllAction" class="d-flex flex-column col-3">
          <ActionButton
            v-if="!this.allshowTabs"
            id="btnExpand"
            class="expand"
            i="fas fa-expand-alt"
            text="Expandir Todo"
            variant="outline-success"
            @click="onToggleTabs"
          />
          <ActionButton
            v-if="this.allshowTabs"
            id="btnColaps"
            class="colaps"
            i="fas fa-compress-alt"
            text="Colapsar Todo"
            variant="outline-danger"
            @click="onToggleTabs"
          />
        </div>
        <div class="d-flex flex-column col-2 offset-md-4">
          <check-box
            v-if="canShowSellectAllAction"
            v-model="allSelected"
            class="checkbox"
            text="Seleccionar Todos"
            @input="onSelectAll"
          />
        </div>
        <div class="d-flex flex-column col-3">
          <ActionButton
            v-if="canShowFinalizeAction"
            id="btnFinalizePeriod"
            class="search"
            i="fas fa-check-circle"
            text="Finalizar Periodo"
            variant="outline-success"
            @click="onFinalizePeriod"
          />

          <ActionButton
            v-if="canShowUnFinalizeAction"
            id="btnUnfinalizePeriod"
            class=""
            i="fas fa-check-circle"
            text="Desfinalizar Periodo"
            variant="outline-danger"
            @click="onFinalizePeriod"
          />
        </div>
      </div>
    </div>

    <custom-result-not-found
      v-if="results.length == 0"
      :text="'No hay información disponible.'"
    />
    <template v-else>
      <div v-if="getFinalizedPeriodStatus">
        <p class="bg-secondary-3 rounded py-3 px-4">
          <b class="mr-2">
            El proceso de finalización de periodo se encuentra en estatus
          </b>
          <span
            :class="
              `badge badge-pill font-16  mx-auto color-black bg-${getFinalizedPeriodStatus.color}`
            "
          >
            {{ getFinalizedPeriodStatus.text }}
          </span>
        </p>
      </div>
      <EndTermResultRowVue
        v-for="(row, index) of results"
        :key="`result-${index}`"
        ref="rowRefs"
        :academic-year="filterModel.academicYear"
        class="mb-3"
        :data="row"
        :error-messages="row.errorMessages || visitErrorMessages(row.visitId)"
        :period="filterModel.period"
        :specialist-id="
          filterModel.specialist != null ? filterModel.specialist.id : null
        "
        @reload-info="onRefresh()"
      />
      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        show-text
        @pagination-go-page="goToPageHandler"
      />
    </template>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import ActionButton from 'ActionButton';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import EndTermResultRowVue from './components/EndTermResultRow.vue';
import CheckBox from 'CheckBox';

import ReportServices from '@/services/common/report.api';
import {
  getInitFilters as _getInitFilters,
  searchGroup as _searchGroup,
  finalizeperiod as _finalizeperiod,
  getVisitsErrors as _getVisitsErrors,
  getEndtermFinalizedPeriodStatus as _getEndtermFinalizedPeriodStatus,
} from '@/services/provider/end-term.api.js';
import {
  getDisciplineService as _getDisciplineService,
  getActiveProviders as _getActiveProviders,
  getActiveSpecialistsByProvider as _getActiveSpecialistsByProvider,
} from '@/services/provider/services-month-certification.api.js';
import { getMonthsInAcademicYear as _getMonthsInAcademicYear } from '@/services/provider/billing-history.api.js';
import { getSpecialistByUserId as _getSpecialistByUserId } from '@/services/provider/specialist.api';
import endTermStatus from '@/utils/constants/endTermStatus';
import { signatureTypes } from '@/utils/constants/signatureTypes';
import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator';
import roles from '@/utils/constants/roles.js';
import { mapGetters } from 'vuex';
import utils from '@/utils/utilities';
import servicesTypes from '@/utils/constants/serviceTypes.js';
import signatureDocumentStatus from '@/utils/constants/signatureDocumentStatus.js';
const DEFAULT_PAGE_SIZE = 20;

const initialFilterModel = () => ({
  serviceType: null,
  disciplineType: null,
  specialist: null,
  status: null,
  alertType: null,
  studentSie: null,
  contractNumber: null,
  intervenedService: null,
  signatureType: null,
  signatureStatus: null,
});

export default {
  name: 'EndTermManagementMain',
  mixins: [alertMixin, storeMixin],
  components: {
    PageHeader,
    FilterManager,
    ActionButton,
    CustomSeparator,
    CustomResultNotFound,
    EndTermResultRowVue,
    Pagination,
    CheckBox,
  },
  data: () => ({
    showTabs: false,
    isFinalizedResults: false,
    totalCount: 0,
    filterModel: {
      academicYear: null,
      period: null,
      provider: null,
      specialist: null,
      status: null,
      disciplineService: null,
      SIENumber: null,
      signatureType: null,
      signatureStatus: null,
    },
    filterOptions: {
      academicYears: [],
      periods: [],
      providers: [],
      specialists: [],
      statuses: [],
      disciplineServices: [],
      signatureTypes: [],
      signatureStatus: [],
    },
    pagination: {
      currentPage: 1,
      totalItemCount: 1,
      pageCount: 1,
      count: 1,
      pageSize: DEFAULT_PAGE_SIZE,
    },
    filterModelSnapshot: {
      academicYear: null,
      period: null,
      provider: null,
      specialist: null,
      status: null,
      disciplineService: null,
      SIENumber: null,
      signatureType: null,
      signatureStatus: null,
    },
    results: [],
    visitsErrors: [],
    finalizedPeriodStatus: null,
    isHandwrittenResults: false,
    isElectronicResults: false,
    isVisitCertificationsVisible: false,
  }),
  computed: {
    allSelected() {
      return this.results.every((row) => row.selected);
    },
    allshowTabs() {
      return this.results.every((row) => row.showTabs);
    },
    ...mapGetters('$_user', ['fullProfile', 'companies']),
    headerConfig() {
      return {
        title: 'Finalización de Periodo',
        icon: 'fas fa-user-tie',
        routes: ['Inicio', 'Proveedor', 'Finalización de Periodo'],
      };
    },
    headerActionsConfig() {
      return [
        {
          text: 'Certificaciones de Visitas - Manuscrita',
          icon: 'fas fa-user-check pr-1',
          variant: 'success',
          visible: this.isVisitCertificationsVisible,
          click: () => this.downloadMassVisitCertifications(),
        },
        {
          text: 'Certificaciones de Visitas - Electrónica',
          icon: 'fas fa-user-check pr-1',
          variant: 'success',
          visible: this.showElectronicVisitCertificationsAction,
          click: () => this.queueMassVisitCertifications(),
        },
      ];
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.filterOptions.academicYears,
          label: 'Año Académico:',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-2',
          clearable: false,
          error: 'El año académico es requerido.',
        },
        {
          name: 'period',
          component: 'CustomDropDown',
          options: this.filterOptions.periods,
          label: 'Periodo:',
          placeholder: 'Seleccione',
          fieldName: 'monthDesc',
          fieldKey: 'monthNumber',
          class: 'col-12 col-md-2',
          validations: 'required',
          error: 'El periodo es requerido.',
        },
        {
          name: 'provider',
          component: 'CustomDropDown',
          options: this.filterOptions.providers,
          label: 'Proveedor:',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-3',
          validations: 'required',
          error: 'El proveedor es requerido.',
          disabled: this.disableProviderDropdown,
        },
        {
          name: 'specialist',
          component: 'CustomDropDown',
          options: this.filterOptions.specialists,
          label: 'Especialista:',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-3',
          validations: 'required',
          error: 'El especialista es requerido.',
          disabled: this.disableSpecialistDropdown,
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.filterOptions.statuses,
          label: 'Estatus:',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-2',
          validations: 'required',
          error: 'El estatus es requerido.',
        },
        {
          name: 'disciplineService',
          component: 'CustomDropDown',
          options: this.filterOptions.disciplineServices,
          label: 'Servicio:',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-2',
        },
        {
          name: 'signatureType',
          component: 'CustomDropDown',
          options: this.filterOptions.signatureTypes,
          label: 'Tipo de Firma:',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-2',
        },
        {
          name: 'signatureStatus',
          component: 'CustomDropDown',
          options: this.filterOptions.signatureStatus,
          label: 'Estatus de Firma:',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-3',
          visible: this.showSignatureStatus,
        },
        {
          name: 'SIENumber',
          component: 'CustomInput',
          label: 'Número de SIE o Contrato:',
          placeholder: 'Escriba Número de SIE o Contrato',
          value: this.filterModel.SIENumber,
          class: 'col-12 col-md-3',
        },
      ];
    },
    disableProviderDropdown() {
      return this.filterOptions.providers.length === 1;
    },
    disableSpecialistDropdown() {
      return this.filterOptions.specialists.length === 1;
    },
    canShowFinalizeAction() {
      return (
        this.results.length > 0 &&
        this.filterModel.status?.id == endTermStatus.NotFinalized &&
        this.searchSuccess &&
        (this.finalizedPeriodStatus == null ||
          this.finalizedPeriodStatus == endTermStatus.NotFinalized ||
          this.finalizedPeriodStatus == endTermStatus.Finalized)
      );
    },
    canShowUnFinalizeAction() {
      return (
        this.results.length > 0 &&
        this.filterModel.status?.id == endTermStatus.Finalized &&
        this.allHasNotBillOrIsPreliminaryBill === true &&
        this.allHasNotPendingReviewBillAdjustment === true &&
        this.searchSuccess
      );
    },
    canShowSellectAllAction() {
      return this.results.length > 0;
    },
    hasPersistedInfo() {
      return (
        !!this.moduleData?.EndTermManagementMain &&
        this.previousRoute?.name === 'visitRegistry'
      );
    },
    isProviderRp() {
      return this.fullProfile?.roleid?.toUpperCase() === roles.Provider_RP;
    },
    isSpecialistRp() {
      return this.fullProfile?.roleid?.toUpperCase() === roles.Specialist_RP;
    },
    isAssistantProviderRP() {
      return (
        this.fullProfile?.roleid?.toUpperCase() === roles.Assistant_Provider_RP
      );
    },
    visitsIds() {
      return this.results.map((x) => x.visitId);
    },
    visitErrorMessages() {
      return (visitId) => {
        return (this.visitsErrors || [])
          .filter((x) => x.visitId === visitId)
          .map((x) => x.errorMessage);
      };
    },
    getFinalizedPeriodStatus() {
      if (!this.finalizedPeriodStatus) return null;

      let value = {
        color: 'yellow',
        text: 'Pendiente',
      };

      switch (this.finalizedPeriodStatus) {
        case endTermStatus.InProcess:
          value.color = 'orange-light';
          value.text = 'En Proceso';
          break;
        case endTermStatus.NotFinalized:
          value.color = 'brown';
          value.text = 'No Completado';
          break;
        case endTermStatus.Finalized:
          value.color = 'green-light';
          value.text = 'Completado';
          break;
        default:
          break;
      }
      return value;
    },
    showSignatureStatus() {
      return this.filterModel.signatureType?.id === signatureTypes.Electronic;
    },
    hasNotGeneratedDocuments() {
      return this.results.some(
        (x) =>
          x.digitalSignatureDocumentStatusId ===
          signatureDocumentStatus.DocNotGenerated
      );
    },
    showHandwrittenVisitCertificationsAction() {
      return (
        this.filterModel?.status?.id === endTermStatus.Finalized &&
        this.filterModel?.signatureType?.id === signatureTypes.Handwritten &&
        this.totalCount > 0
      );
    },
    showElectronicVisitCertificationsAction() {
      return (
        this.filterModel?.status?.id === endTermStatus.Finalized &&
        this.filterModel?.signatureType?.id === signatureTypes.Electronic &&
        this.hasNotGeneratedDocuments === true &&
        this.totalCount > 0
      );
    },
    allHasNotBillOrIsPreliminaryBill() {
      return this.results.every(
        (item) => item.hasNotBillOrIsPreliminaryBill === true
      );
    },
    allHasNotPendingReviewBillAdjustment() {
      return this.results.every(
        (item) => item.hasPendingReviewBillAdjustment === false
      );
    },
  },
  watch: {
    results: 'updateVisitCertificationsVisibility',
    'filterModel.signatureType': function(newVal) {
      if (!newVal || newVal.id === signatureTypes.Handwritten) {
        this.filterModel.signatureStatus = null;
      }
      if (!newVal || newVal.id === signatureTypes.Electronic) {
        this.filterModel.signatureStatus = null;
      }
    },
  },
  async mounted() {
    if (!this.hasPersistedInfo) this.filterModel = { ...initialFilterModel() };

    await this.getInitFilters();

    if (this.hasPersistedInfo) this.onSearch();
    this.totalCount = 0;
  },
  methods: {
    onToggleTabs() {
      this.showTabs = !this.showTabs;
      if (!this.showTabs && !this.results.every((row) => row.showTabs)) {
        return;
      }
      this.results.forEach((x) => {
        x.showTabs = this.showTabs;
      });
    },
    onSelectAll(value) {
      if (!value && !this.results.every((row) => row.selected)) {
        return;
      }
      this.results.forEach((x) => {
        x.selected = value;
      });
    },
    async getInitFilters() {
      if (this.hasPersistedInfo) return;

      const { filters, collections } = (await _getInitFilters()).data;
      this.filterModel = {
        ...this.filterModel,
        ...filters,
      };
      this.filterOptions = {
        ...this.filterOptions,
        ...collections,
      };
      this.onChangeAcademicYear(this.filterModel.academicYear);
    },
    async onChangeAcademicYear(value) {
      if (value?.id) {
        const { data } = await _getMonthsInAcademicYear(value.id);
        this.filterOptions.periods = data;
        this.filterModel.period = null;

        this.filterOptions.providers = (
          await _getActiveProviders(
            value.id,
            this.filterModel.period?.monthNumber
          )
        ).data;
        this.filterModel.provider = null;

        this.onChangePeriod();

        if (
          this.isProviderRp ||
          this.isSpecialistRp ||
          this.isAssistantProviderRP
        ) {
          if (this.companies?.length === 1) {
            const { id, name } = this.companies[0];
            const currentCompanyIsSelectable = this.filterOptions.providers.find(
              (provider) => provider.id == id
            );

            let selectedProvider = {
              id,
              name,
              disabled: true,
              sortOrder: 0,
              isDirty: false,
              selected: true,
              keyId: '00000000-0000-0000-0000-000000000000',
            };

            this.filterOptions.providers = currentCompanyIsSelectable
              ? [selectedProvider]
              : [];
            this.filterModel.provider = currentCompanyIsSelectable
              ? selectedProvider
              : null;
          } else {
            this.filterOptions.providers = this.companies;
          }
        }

        if (this.isSpecialistRp) {
          const { data } = await _getSpecialistByUserId();
          let selectedSpecialist = {
            id: data.id,
            name: data.name,
            disabled: true,
            sortOrder: 0,
            isDirty: false,
            selected: true,
            keyId: '00000000-0000-0000-0000-000000000000',
          };

          this.filterOptions.specialists = [selectedSpecialist];
          this.filterModel.specialist = selectedSpecialist;
        }
      }
    },
    async onChangePeriod() {
      if (
        !this.isProviderRp &&
        !this.isSpecialistRp &&
        !this.isAssistantProviderRP
      ) {
        this.filterModel.provider = null;
        this.filterOptions.providers = (
          await _getActiveProviders(
            this.filterModel.academicYear.id,
            this.filterModel.period?.monthNumber
          )
        ).data;

        if (this.disableProviderDropdown) {
          this.filterModel.provider = this.filterOptions.providers[0];
        }
      } else if (this.filterModel.period?.monthNumber == 7) {
        const { id, name } = this.companies[0];
        this.filterOptions.providers = (
          await _getActiveProviders(
            this.filterModel.academicYear.id,
            this.filterModel.period?.monthNumber
          )
        ).data;

        const currentCompanyIsSelectable = this.filterOptions.providers.find(
          (provider) => provider.id == id
        );
        let selectedProvider = {
          id,
          name,
          disabled: true,
          sortOrder: 0,
          isDirty: false,
          selected: true,
          keyId: '00000000-0000-0000-0000-000000000000',
        };
        this.filterOptions.providers = currentCompanyIsSelectable
          ? [selectedProvider]
          : [];
        this.filterModel.provider = currentCompanyIsSelectable
          ? selectedProvider
          : null;
      } else {
        this.filterOptions.provider = null;
      }
      this.onChangeProvider(this.filterModel.provider);
    },
    async onChangeProvider(value) {
      if (!this.isSpecialistRp) {
        this.filterModel.specialist = null;
      }
      this.filterOptions.specialists = [];
      if (value?.id && this.filterModel.period?.monthNumber) {
        const academicYearId = this.filterModel.academicYear.id;
        const monthNumber = this.filterModel.period?.monthNumber;
        this.filterOptions.specialists = (
          await _getActiveSpecialistsByProvider(
            academicYearId,
            monthNumber,
            value.id
          )
        ).data;

        if (this.disableSpecialistDropdown) {
          this.filterModel.specialist = this.filterOptions.specialists[0];
        }
      }

      this.onChangeSpecialist(this.filterModel.specialist);
    },
    async onChangeSpecialist(value) {
      this.filterModel.disciplineService = null;
      this.filterOptions.disciplineServices = [];
      this.filterModel.status = null;
      if (
        value?.id &&
        this.filterModel.academicYear?.id &&
        this.filterModel.period?.monthNumber &&
        this.filterModel.provider?.id
      ) {
        const academicYearId = this.filterModel.academicYear.id;
        const periodId = this.filterModel.period.monthNumber;
        const providerId = this.filterModel.provider.id;
        this.filterOptions.disciplineServices = (
          await _getDisciplineService(
            academicYearId,
            periodId,
            providerId,
            value.id
          )
        ).data;
      }
    },
    async onChangeStatus() {
      this.filterModel.disciplineService = null;
      this.searchSuccess = false;
    },
    fillPayload(page) {
      const payload = {
        academicYearId: this.filterModel.academicYear?.id,
        monthNumber: this.filterModel.period?.monthNumber,
        companyId: this.filterModel.provider?.id,
        specialistId: this.filterModel.specialist.id,
        disciplineTypeId: this.filterModel.disciplineService?.id,
        status: this.filterModel.status?.id,
        contractOrSieNumber: this.filterModel.SIENumber,
        SignatureTypeId: this.filterModel.signatureType?.id,
        SignatureStatusId: this.filterModel.signatureStatus?.id,
        pageIndex: page ? page : 1,
        pageSize: this.pagination.pageSize,
      };
      return payload;
    },
    async onSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (!isValid) {
        await this.$refs.filterRef.$refs.formValidator.reset();
        await this.$refs.filterRef.$refs.formValidator.validate();
        this.ShowToast('Error', 'Información Incompleta', 'error');
        return;
      }

      const payload = this.fillPayload(1);
      await this.searchEndTerm(payload);
      this.closeTabOnSeach();
    },
    async searchEndTerm(payload) {
      const res = (await _searchGroup(payload)).data;
      this.results = [...res.data];
      this.visitsErrors = [];
      this.results = res.data.map((x) => ({
        ...x,
        selected: false,
        showTabs: false,
      }));
      this.pagination = {
        ...this.pagination,
        count: res.count,
        currentPage: res.currentPage,
        pageCount: res.pageCount,
        totalItemCount: res.totalItemCount,
      };
      this.totalCount =
        this.results.length > 0 ? this.results[0].totalService : 0;
      this.searchSuccess = true;
      this.isFinalizedResults =
        this.filterModel.status?.id === endTermStatus.Finalized;
      this.isHandwrittenResults =
        this.filterModel.signatureType?.id === signatureTypes.Handwritten;
      this.isElectronicResults =
        this.filterModel.signatureType?.id === signatureTypes.Electronic;
      this.filterModelSnapshot = { ...this.filterModel };
    },
    async onRefresh() {
      const payload = this.fillPayload(1);
      await this.searchEndTerm(payload);
    },
    async goToPageHandler(page) {
      const payload = this.fillPayload(page);
      await this.searchEndTerm(payload);
    },
    async onFinalizePeriod() {
      const finalizePeriod =
        this.filterModel.status?.id == endTermStatus.Finalized;

      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea ${
          finalizePeriod ? 'desfinalizar' : 'finalizar'
        } el periodo seleccionado?`,
        'Sí',
        'No'
      );

      if (!answer) return;

      const filteredresults = this.results.filter((x) => x.selected == true);
      if (filteredresults.length == 0) {
        this.dataSelected = this.results;
      } else {
        this.dataSelected = filteredresults;
      }
      if (filteredresults && filteredresults.length > 0) {
        if (
          filteredresults.filter(
            (x) =>
              x.hasInterventionPlan == false &&
              x.serviceTypeId == servicesTypes.Therapy
          ).length > 0 &&
          !finalizePeriod
        ) {
          this.ShowToast(
            'Error.',
            `No se puede finalizar el periodo, ya que, no todos los contratos cuentan con Plan de Intervención.`,
            'error'
          );
          return;
        }
      } else {
        if (
          this.results.filter(
            (x) =>
              x.hasInterventionPlan == false &&
              x.serviceTypeId == servicesTypes.Therapy
          ).length > 0 &&
          !finalizePeriod
        ) {
          this.ShowToast(
            'Error.',
            `No se puede finalizar el periodo, ya que, no todos los contratos cuentan con Plan de Intervención.`,
            'error'
          );
          return;
        }
      }

      const payload = this.dataSelected.map((s) => ({
        academicYearId: this.filterModel.academicYear?.id,
        monthNumber: this.filterModel.period?.monthNumber,
        companyId: this.filterModel.provider?.id,
        specialistId: this.filterModel.specialist.id,
        finalizedFlag: !finalizePeriod,
        visitSummaryId: s.visitSummaryId,
      }));

      const { data } = await _finalizeperiod(payload);

      await this.onSearch();

      if (data.isValid) {
        this.ShowToast(
          'Proceso Exitoso.',
          `El periodo ha sido ${
            finalizePeriod ? 'desfinalizado' : 'finalizado'
          } exitosamente.`,
          'success'
        );
      } else {
        this.ShowToast('Alerta', data.message, 'error');
      }
    },
    async downloadMassVisitCertifications() {
      if (!this.isFinalizedResults) {
        this.ShowToast(
          'Alerta',
          'Para descargar la certificaciones de visitas el estatus debe estar finalizado.',
          'error'
        );
        return;
      }

      if (!this.isHandwrittenResults) {
        this.ShowToast(
          'Alerta',
          'Para descargar la certificaciones de visitas el estatus de firma debe ser manuscrita.',
          'error'
        );
        return;
      }

      let payload = this.fillPayload(1);
      payload.visitSummaryIds = [];

      var hasSelected = this.results.some((x) => x.selected === true);
      if (hasSelected === true) {
        payload.visitSummaryIds = this.results
          .filter((x) => x.selected === true)
          .map((x) => x.visitSummaryId);
      }

      await ReportServices.getServiceCertificates(payload)
        .then((res) => {
          utils.convertToBlob(res.data);
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async queueMassVisitCertifications() {
      if (!this.isFinalizedResults) {
        this.ShowToast(
          'Alerta',
          'Para descargar la certificaciones de visitas el estatus debe estar finalizado.',
          'error'
        );
        return;
      }

      if (!this.isElectronicResults) {
        this.ShowToast(
          'Alerta',
          'Para descargar la certificaciones de visitas el estatus de firma debe ser electrónica.',
          'error'
        );
        return;
      }

      let payload = this.fillPayload(1);
      payload.visitSummaryIds = [];
      payload.isDropShipping = true;

      var hasSelected = this.results.some((x) => x.selected === true);
      if (hasSelected === true) {
        payload.visitSummaryIds = this.results
          .filter((x) => x.selected === true)
          .map((x) => x.visitSummaryId);
      }

      await ReportServices.queueServiceCertificates(payload)
        .then(async () => {
          this.ShowToast(
            'Proceso Exitoso.',
            'Los documentos han sido generados exitosamente.',
            'success'
          );
          await this.goToPageHandler(this.pagination.currentPage);
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async getVisitsErrors() {
      const { data } = await _getVisitsErrors(this.visitsIds);
      this.visitsErrors = [...data];
      return this.visitsErrors.length > 0;
    },
    async getEndtermFinalizedPeriodStatus() {
      const payload = {
        academicYearId: this.filterModel.academicYear?.id,
        monthNumber: this.filterModel.period?.monthNumber,
        companyId: this.filterModel.provider?.id,
        specialistId: this.filterModel.specialist.id,
      };
      const { data } = await _getEndtermFinalizedPeriodStatus(payload);
      this.finalizedPeriodStatus = data ? data : null;
    },
    async updateVisitCertificationsVisibility() {
      this.isVisitCertificationsVisible =
        this.filterModel.status?.id === endTermStatus.Finalized &&
        this.filterModel.signatureType?.id === signatureTypes.Handwritten &&
        this.totalCount > 0;
    },
    closeTabOnSeach() {
      this.$refs.rowRefs.forEach((row) => {
        row.closeTabAction();
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => (vm.previousRoute = from));
  },
  destroyed() {
    this.persistData(['pagination', 'results'], true);
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
</style>
